module.exports = new __parcel__URL__("figurative.6ffba798.webp").toString();